import { parseRefractiveIndex } from 'physical-parser';
import { extractExperimentalData } from './extractExperimentalData';
/**
 * Returns the refractive index of a compound
 * @param data Data of a compound data request to the PubChem API
 * @returns ExperimentalData
 */
export function getRefractiveIndex(data = {}) {
    const refractiveIndex = extractExperimentalData(data, 'Refractive Index', {
        parser: (value) => parseRefractiveIndex(value),
    });
    return refractiveIndex;
}
//# sourceMappingURL=getRefractiveIndex.js.map